export const ROUTE_MAP_GEO_FENCES_SOURCE = 'routeMapGeoFencesSource';
export const ROUTE_MAP_HAULER_LOCATIONS_LAYER = 'routeMapHaulerLocationsLayer';
export const ROUTE_MAP_ROUTE_STOPS_LAYER = 'routeMapRouteStopsLayer';
